import { Card, Typography, Box, Grid, Table, TableBody, TableCell, TableHead, TableRow, TableContainer } from '@mui/material';
import ReactApexChart from 'react-apexcharts';
import formatMoney from 'src/utils/formatMoney';
import { getStageDisplayName } from 'src/utils/stageDisplay';

// Pipeline funnel: one horizontal bar per stage (pattern TeamPerformance/PMFunnel.js).
// Bar / row click drills to that stage's deals (won stage → won lifecycle).
export default function FunnelSection({ funnel, currencyId, currencyLabel, openDrill }) {
  const rows = funnel || [];
  if (!rows.length) {
    return (
      <Card sx={{ p: 2, mb: 3 }}>
        <Typography variant="h6" fontWeight={600} mb={1}>Pipeline Funnel</Typography>
        <Typography variant="body2" color="text.secondary">No pipeline data for this selection.</Typography>
      </Card>
    );
  }

  const drillStage = (idx) => {
    const row = rows[idx];
    if (!row) return;
    openDrill(
      { lifecycle: row.percentage === 100 ? 'won' : 'open', stage_id: row.stage_id, currency_id: currencyId },
      `${getStageDisplayName(row.stage_label)} deals`,
    );
  };

  const chart = {
    series: [{ name: 'Deals', data: rows.map((f) => f.count) }],
    options: {
      chart: {
        type: 'bar', toolbar: { show: false }, height: 360,
        events: {
          dataPointSelection: (event, ctx, config) => drillStage(config.dataPointIndex),
        },
      },
      plotOptions: { bar: { horizontal: true, borderRadius: 4, distributed: true } },
      xaxis: { categories: rows.map((f) => getStageDisplayName(f.stage_label)) },
      grid: { borderColor: '#eee' },
      dataLabels: { enabled: true, formatter: (v) => v.toLocaleString() },
      legend: { show: false },
      tooltip: { y: { formatter: (v) => `${v} deals` } },
    },
  };

  return (
    <Card sx={{ p: 2, mb: 3 }}>
      <Typography variant="h6" fontWeight={600} mb={1}>Pipeline Funnel</Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={7}>
          <Box sx={{ minHeight: 360 }}>
            <ReactApexChart options={chart.options} series={chart.series} type="bar" height={360} />
          </Box>
        </Grid>
        <Grid item xs={12} md={5}>
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Stage</TableCell>
                  <TableCell align="right">Count</TableCell>
                  <TableCell align="right">TCV</TableCell>
                  <TableCell align="right">Conv.</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((f, idx) => (
                  <TableRow
                    key={f.stage_id}
                    hover
                    onClick={() => drillStage(idx)}
                    sx={{ cursor: 'pointer' }}
                  >
                    <TableCell>{getStageDisplayName(f.stage_label)}</TableCell>
                    <TableCell align="right">{f.count}</TableCell>
                    <TableCell align="right">{formatMoney(f.tcv, currencyLabel)}</TableCell>
                    <TableCell align="right">
                      {f.conversion_pct === null || f.conversion_pct === undefined
                        ? '—' : `${(f.conversion_pct * 100).toFixed(1)}%`}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </Card>
  );
}
